var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-outages-search" }, [
    _c(
      "form",
      {
        staticClass: "c-outages-search__form",
        class: {
          "c-outages-search__form--list-view": _vm.outagePageView === "list",
        },
      },
      [
        _c("label", { staticClass: "c-outages-search__label" }, [
          _vm._v("SEARCH"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "c-outages-search__input-wrapper" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.searchText,
                expression: "searchText",
              },
            ],
            staticClass: "c-outages-search__input",
            attrs: { type: "text", placeholder: "Enter street name" },
            domProps: { value: _vm.searchText },
            on: {
              input: [
                function ($event) {
                  if ($event.target.composing) return
                  _vm.searchText = $event.target.value
                },
                _vm.clearMarkerFilter,
              ],
            },
          }),
          _vm._v(" "),
          _vm.searchText != "" || _vm.filterMarkerSelectedLocation != null
            ? _c("div", { staticClass: "c-outages-search__information" }, [
                _c("span", { staticClass: "c-outages-search__results" }, [
                  _vm._v(
                    _vm._s(_vm.getAllFilteredOutages.length) +
                      " of\n          " +
                      _vm._s(_vm.getAllOutagesByTimeFilter.length) +
                      " results showing"
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass: "c-outages-search__clear",
                    on: { click: _vm.clearAllFilters },
                  },
                  [_vm._v("CLEAR")]
                ),
              ])
            : _vm._e(),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }